import React from "react";
import AboutHero from "./AboutHero";

const About = () => {
  return (
    <section id="about">
      <AboutHero />
    </section>
  );
};

export default About;
